import type {
  PlatformSupportConversationFieldsFragment as Conversation,
  PlatformSupportMessageFieldsFragment as Message,
} from '@web-app/generated/platform/graphql';

export type Confirmations = {
  created: Conversation[];
  replies: Record<string, Message[]>;
};
export const confirmationsKey = (viewerId: string) =>
  ['support-concierge-confirmations', viewerId] as const;
